import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const AppMenuListItemContainer = styled(props => (
  <ListItem classes={{ selected: 'active' }} {...props} />
))`
  && {
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: ${props => props.theme.spacing(0.5)}px;

    & * {
      font-size: 14px;
      font-weight: 500;
      transition: ${props =>
        props.theme.transitions.create('color', {
          duration: props.theme.transitions.duration.shortest,
        })};
    }

    &:hover,
    &:focus {
      background-color: ${props => props.theme.palette.appMenuItems.hover};

      & * {
        color: ${props => props.theme.palette.primary.main};
      }
    }

    &.active,
    &.active:focus {
      background-color: ${props => props.theme.palette.appMenuItems.selected};

      & * {
        color: ${props => props.theme.palette.primary.main};
      }

      &:hover {
        background-color: ${props => props.theme.palette.appMenuItems.selected};
      }
    }
  }
`;

const AppMenuListItem = ({ label, children, ...props }) => (
  <div>
    <AppMenuListItemContainer {...props}>
      <ListItemText primary={label} />
    </AppMenuListItemContainer>
    <div style={{ marginLeft: 8 }}>{children}</div>
  </div>
);

AppMenuListItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  button: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  role: PropTypes.string,
  children: PropTypes.node,
  ...ListItem.propTypes,
};

AppMenuListItem.defaultProps = {
  button: true,
  component: 'li',
  role: 'listitem',
  children: undefined,
};

export default AppMenuListItem;
